
export default {
    data() {
        return {
            items: JSON.parse(window.localStorage.menu)
        }
    }
}